module.exports = "/_next/static/images/download_apple-8c4986ee4828b47d16f5cd694ef065f2.svg";